<template>
	<section class="base-table">
    <div class="table"
         cy="table">
      <ul class="table-header flex"
          cy="table-header">
        <li class="flex-center"
            :class="item.class"
            v-for="(item, index) in tableHeader"
            :key="index">
          <figure v-if="item.title === 'car'"
                  class="is-car">
            <img src="../assets/carInService.svg" alt="car">
          </figure>

          <span v-else-if="item.title === 'client'"
                class="uppercase">
            Client
          </span>

          <span v-else-if="item.title === 'data intrarii'" class="uppercase">
              Data Intrarii
          </span>

          <span v-else
                class="uppercase">
            {{ lang[item.title] }}
          </span>
        </li>
      </ul>


      <ul class="table-row flex"
          :class="{ 'is-expanded': isRowExpanded(index), 'is-mobile-collapsible': isMobile }"
          :cy="`table-row-${index + 1}`"
          @click="handleRowClick(comanda, index)"
          v-for="(comanda, index) in data"
          :key="index">
        <li :class="item.class"
            class="text-center pointer"
            v-for="(item, headerIndex) in tableHeader"
            :key="headerIndex">
          <span v-if="item.class === 'detalii'">
            {{ comanda.observatii | shortenText }}
          </span>

          <span v-else-if="item.class === 'client'"
                class="capitalize">
            {{ comanda.client && comanda.client.nume }}
          </span>

          <span v-else-if="item.class === 'dataIntrarii'"
                class="capitalize">
            {{ formatDateRo(comanda && comanda.createdAt) }}
          </span>

          <a v-else-if="item.class === 'telefon' && isMobile && comanda.client && comanda.client.telefon"
             :href="`tel:${comanda.client.telefon}`"
             class="phone-link"
             @click.stop>
            {{ comanda.client.telefon }}
          </a>

          <span v-else-if="item.class === 'telefon'">
            {{ comanda.client && comanda.client.telefon }}
          </span>

          <span v-else-if="item.class === 'firma'">
            {{ comanda.client && comanda.client.numeFirma ? comanda.client.numeFirma.slice(0, 14) : '' }}
            {{ comanda.client && comanda.client.numeFirma && comanda.client.numeFirma.length > 14 ? '...' : '' }}
          </span>

          <span v-else>{{ comanda[item.class] }}</span>
        </li>

        <li v-if="isMobile"
            class="expand-toggle">
          <button type="button"
                  cy="expand-comanda-btn"
                  :aria-label="isRowExpanded(index) ? 'Ascunde detalii' : 'Vezi detalii'"
                  :aria-expanded="isRowExpanded(index) ? 'true' : 'false'"
                  @click.stop="toggleExpanded(index)">
            <svg width="14"
                 height="9"
                 viewBox="0 0 14 9"
                 xmlns="http://www.w3.org/2000/svg"
                 aria-hidden="true">
              <path d="M1 1L7 7L13 1"
                    stroke="currentColor"
                    stroke-width="1.8"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </button>
        </li>
      </ul>
    </div>

    <div v-if="!noPagination"
         cy="pagination"
         class="pagination flex-center mtop20px">
      <button @click="backPage"
              cy="back-btn"
              class="mright20px flex-center bg-transparent"
              :disabled="+page === 1">
        <svg width="12px" height="21px" viewBox="0 0 12 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M1.3125,20.2304688 C1.22135371,20.2304688 1.13346396,20.2141929 1.04882812,20.1816406 C0.964192285,20.1490884 0.889323242,20.1002607 0.82421875,20.0351562 C0.694009766,19.9049473 0.62890625,19.7486988 0.62890625,19.5664062 C0.62890625,19.3841137 0.694009766,19.2278652 0.82421875,19.0976562 L9.75,10.171875 L0.9609375,1.40234375 C0.830728516,1.27213477 0.765625,1.11263115 0.765625,0.923828125 C0.765625,0.735025098 0.830728516,0.575521484 0.9609375,0.4453125 C1.09114648,0.315103516 1.2506501,0.25 1.43945312,0.25 C1.62825615,0.25 1.78775977,0.315103516 1.91796875,0.4453125 L11.15625,9.703125 C11.286459,9.83333398 11.3515625,9.98958242 11.3515625,10.171875 C11.3515625,10.3541676 11.286459,10.510416 11.15625,10.640625 L1.78125,20.0351562 C1.71614551,20.1002607 1.64127646,20.1490884 1.55664062,20.1816406 C1.47200479,20.2141929 1.39062539,20.2304688 1.3125,20.2304688 Z" id="" fill="#000000" fill-rule="nonzero" transform="translate(5.990234, 10.240234) rotate(-180.000000) translate(-5.990234, -10.240234) "></path>
          </g>
        </svg>
      </button>
      <span class="font-medium"
            cy="page-number"><template v-if="totalPages > 0">{{ page }} / {{ totalPages }}</template><template v-else>{{ page }}</template></span>
      <button @click="nextPage()"
              cy="next-btn"
              class="mleft20px flex-center bg-transparent"
              :disabled="isNextDisabled">
        <svg width="12px" height="21px" viewBox="0 0 12 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M1.3125,20.2304688 C1.22135371,20.2304688 1.13346396,20.2141929 1.04882812,20.1816406 C0.964192285,20.1490884 0.889323242,20.1002607 0.82421875,20.0351562 C0.694009766,19.9049473 0.62890625,19.7486988 0.62890625,19.5664062 C0.62890625,19.3841137 0.694009766,19.2278652 0.82421875,19.0976562 L9.75,10.171875 L0.9609375,1.40234375 C0.830728516,1.27213477 0.765625,1.11263115 0.765625,0.923828125 C0.765625,0.735025098 0.830728516,0.575521484 0.9609375,0.4453125 C1.09114648,0.315103516 1.2506501,0.25 1.43945312,0.25 C1.62825615,0.25 1.78775977,0.315103516 1.91796875,0.4453125 L11.15625,9.703125 C11.286459,9.83333398 11.3515625,9.98958242 11.3515625,10.171875 C11.3515625,10.3541676 11.286459,10.510416 11.15625,10.640625 L1.78125,20.0351562 C1.71614551,20.1002607 1.64127646,20.1490884 1.55664062,20.1816406 C1.47200479,20.2141929 1.39062539,20.2304688 1.3125,20.2304688 Z" id="" fill="#000000" fill-rule="nonzero"></path>
          </g>
        </svg>
      </button>
    </div>
  </section>
</template>

<script>
	import {mapGetters} from "vuex";

  export default {
		name: 'BaseTable',
    props: {
      tableHeader: {
        type: Array,
        required: true,
        default: () => []
      },
      data: {
        type: Array,
        required: true,
        default: () => []
      },
      noPagination: {
        type: Boolean,
        required: false
      },
      page: {
        type: Number,
        required: false,
        default: () => 1
      },
      totalPages: {
        type: Number,
        required: false,
        default: () => 0
      }
    },
    data () {
      return {
        isMobile: false,
        expandedIndexes: [],
        mql: null
      }
    },
    filters: {
      shortenText (val = '') {
        return val.length > 100 ? `${val.substring(0, 30)}...` : val
      }
    },
    computed: {
      ...mapGetters(['lang']),
      isNextDisabled () {
        if (this.totalPages > 0) {
          return +this.page >= this.totalPages
        }
        return this.data.length < 10
      }
    },
    watch: {
      data () {
        this.expandedIndexes = []
      },
      page () {
        this.expandedIndexes = []
      }
    },
    mounted () {
      if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
        this.mql = window.matchMedia('(max-width: 720px)')
        this.isMobile = this.mql.matches
        if (this.mql.addEventListener) {
          this.mql.addEventListener('change', this.handleMediaChange)
        } else if (this.mql.addListener) {
          this.mql.addListener(this.handleMediaChange)
        }
      }
    },
    beforeDestroy () {
      if (this.mql) {
        if (this.mql.removeEventListener) {
          this.mql.removeEventListener('change', this.handleMediaChange)
        } else if (this.mql.removeListener) {
          this.mql.removeListener(this.handleMediaChange)
        }
      }
    },
    methods: {
      handleMediaChange (event) {
        this.isMobile = event.matches
        if (!event.matches) {
          this.expandedIndexes = []
        }
      },
      isRowExpanded (index) {
        return this.expandedIndexes.indexOf(index) !== -1
      },
      handleRowClick (comanda) {
        this.$emit('click-item', comanda)
      },
      toggleExpanded (index) {
        const position = this.expandedIndexes.indexOf(index)
        if (position === -1) {
          this.expandedIndexes.push(index)
        } else {
          this.expandedIndexes.splice(position, 1)
        }
      },
      goToComanda (item) {
        this.$emit('click-item', item)
      },
      backPage () {
        this.$emit('change-page', +this.page - 1)
      },
      nextPage () {
        this.$emit('change-page', +this.page + 1)
      },
      formatDateRo(ISO) {
        const date = new Date(ISO);

        let formatted = date.toLocaleDateString("ro-RO", {
          day: "numeric",
          month: "short",
          year: "2-digit"
        });

        formatted = formatted.replace(/(\d+)\s(\w+)\.?\s(\d{2})/, (_, d, m, y) => {
          return `${d} ${m.charAt(0).toUpperCase() + m.slice(1)}. '${y}`;
        });

        return formatted;
      }
    },
  }
</script>

<style lang="less">
	.base-table {
    .table {
      min-height: 390px;
    }
    .table-header {
      height: 28px;
      margin-top: 20px;
      li {
        margin-right: 1px;
        border-bottom: 1px solid @dark-gray;
        font-size: 1.4rem;
        padding: 8px;
      }
    }
    .table-row {
      padding: 6px 0;
      font-size: 1.9rem;
      &:hover {
        background-color: rgba(0, 0, 0, .03);
      }
    }
	}
</style>
